import Vue from 'vue'
import Vuex from 'vuex'
import api from '../api/api'
import vm from '../main'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState({
    storage: window.sessionStorage,
  })],
  state: {
    user: {}
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    clearUser(state) {
      state.user = {};
    }
  },
  actions: {
    getUser({ commit }) {
      api.getUserData()
        .then(res => { 
          commit('setUser', res.data);
          vm.$i18n.locale = (localStorage.getItem("lang") ? localStorage.getItem("lang") : res.data.language.toLowerCase());
        })
        .catch(err => err);
    },
    removeUserData({ commit }) {
      commit('clearUser');
      sessionStorage.clear();
    }
  }
})